<div style="padding: 16px">
  <div style="margin-bottom: 16px">
    <app-date-range-selector
      (dateRangeChange)="onRangeChange($event)"
      [dateRange]="rango"
    ></app-date-range-selector>
  </div>

  <app-tabla
    [datos]="viajes"
    [columnas]="columnas"
    [paginatorArriba]="false"
    [totalCount]="viajes?.length || 0"
    [emptyState]="{ title: 'No hay viajes en el rango seleccionado' }"
  ></app-tabla>
</div>
